<template>
    <div class="payment-app" id="direct-support-app">

        <div v-if="!isCustomSelected" class="payment-options x-row">
          <div v-for="(option, index) in paymentOptions"
               :key="option.index"
               :class="{selected: index === selectedOptionIndex}"
               @click="selectOption(index)"
               class="payment-option x-col">
            <span>{{ option.label }}</span>
          </div>
        </div>

        <div v-if="isCustomSelected" class="row mb-3">
          <div class="custom-amount input-group col-xs-6 col-sm-4"
               :class="{'has-error': v$.amount.$error }">
              <label for="id_customer_amount" class="form-label" v-if="widgetSettings.supportType!='link'">Kwota wpłaty:</label>
              <div class="input-group">
                <input type="text" name="custome_amount" id="id_customer_amount" class="form-control" ref="customAmountInput"
                      @input="v$.amount.$touch();v$.customAmount.$touch();"
                      v-model.trim="customAmount"/>
                <span class="input-group-text">zł</span>
              </div>
              <label v-if="v$.amount.$error" for="id_customer_amount" class="help-block form-text">Wpisz poprawną kwotę, minimum 1 zł</label>
          </div>
        </div>

        <template v-if="widgetSettings.supportType==='single'">
          <div v-if="showSupportTarget" class="row">
            <div class="support-target form-group col-xs-12">
                <label for="id_support_target" class="form-label">Cel szczegółowy (opcjonalnie):</label>
                <input type="text" name="support_target" id="id_support_target" class="form-control" ref="supportTargetInput"
                      @input="v$.supportTarget.$touch();"
                      v-model.trim="supportTarget"/>
                <label for="id_support_target" class="help-block form-text">
                  Np. nazwisko podopiecznego fundacji
                </label>
            </div>
          </div>
          <a v-else @click="showTarget" href="#" class="show-support-target">
            Chcę wpisać cel szczegółowy &#9656;
          </a>
        </template>

        <div class="checkbox handle-costs" v-if="widgetSettings.supportType!='link'">
          <label for="id_handle_costs" class="form-label">
            <input type="checkbox" v-model="handleCosts" id="id_handle_costs">
              Chcę pokryć koszty obsługi płatności online<span v-if="widgetSettings.supportType!=='recurring'"> w wysokości 1,49%</span>,
              aby do organizacji trafiła pełna kwota
          </label>
        </div>

        <div class="personal-info row mb-3">
          <div class="form-group customer-first-name col-sm-3" 
               :class="{'has-error': v$.customer_first_name.$error }">
            <label for="id_customer_first_name" class="form-label">Imię</label>
            <input type="text" name="customer_first_name" id="id_customer_first_name" class="form-control"
                   @input="delayTouch(v$.customer_first_name)"
                   v-model.trim="customer_first_name"/>
            <label v-if="v$.customer_first_name.$error" for="id_customer_first_name" class="help-block form-text">
              Wpisz imię
            </label>
          </div>
          <div class="form-group customer-last-name col-sm-3" 
               :class="{'has-error': v$.customer_last_name.$error }">
            <label for="id_customer_last_name" class="form-label">Nazwisko</label>
            <input type="text" name="customer_last_name" id="id_customer_last_name" class="form-control"
                   @input="delayTouch(v$.customer_last_name)"
                   v-model.trim="customer_last_name"/>
            <label v-if="v$.customer_last_name.$error" for="id_customer_last_name" class="help-block form-text">
              Wpisz nazwisko
            </label>
          </div>
          <div class="form-group customer-first-name col-sm-6" 
               :class="{'has-error': v$.customer_email.$error }">
            <label for="id_customer_email" class="form-label">E-mail</label>
            <input type="email" name="customer_email" id="id_customer_email" class="form-control"
                   @input="delayTouch(v$.customer_email)"
                   v-model.trim="customer_email"/>
            <label v-if="v$.customer_email.$error" for="id_customer_email" class="help-block form-text">
              Wpisz poprawny adres e-mail
            </label>
          </div>
        </div>

        <div class="row" v-if="widgetSettings.supportType==='recurring'">
          <div class="support-day form-group col-xs-12 mb-3">
              <label class="form-label d-block">Dzień płatności:</label>
              <div class="form-check form-check-inline" v-for="supportday in widgetSettings.supportRecurringDays">
                  <input type="radio"
                    :value="supportday.day"
                    name="support_day"
                    v-model="support_day"
                    @change="selectSupportDay(supportday.day)"
                    class="form-check-input"
                    :id="('support_day'+supportday.day)"/>                
                  <label class="form-check-label" :for="('support_day'+supportday.day)">{{supportday.day}}. dzień miesiąca</label>
              </div>
              
          </div>
        </div>

        

        <div class="checkbox accepted-terms form-group"
             :class="{'has-error': v$.acceptedTerms.$error }">
          <label for="id_accepted_terms">
            <input type="checkbox" id="id_accepted_terms"
                   v-model="acceptedTerms"
                   @input="v$.acceptedTerms.$touch()">
            <span v-if="!acceptTermsUnfolded">
              Akceptuję regulamin wpłacającego i wyrażam zgodę na przetwarzanie moich danych osobowych celem obsługi płatności...
              <span class="link" @click="acceptTermsUnfolded = true; $event.preventDefault();">więcej</span>
            </span>
            <span v-if="acceptTermsUnfolded">
              Akceptuję regulamin wpłacającego i wyrażam zgodę na przetwarzanie moich danych osobowych celem obsługi płatności zgodnie z ustawą o ochronie danych osobowych z dnia 10 maja 2018 r. przez Fundację FaniMani z siedzibą w Poznaniu, ul. Macieja Palacza 144 oraz odpowiednio do wybranego sposobu płatności - Blue Media S.A. z siedzibą w Sopocie lub Krajowy Integrator Płatności S.A. (Tpay) z siedzibą w Poznaniu.
            </span>
          </label>
          <label v-if="v$.acceptedTerms.$error" for="id_customer_email" class="help-block form-text">
            Zgoda jest wymagana
          </label>
          <label v-if="customMarketingConsent">
            <input v-model="form_marketing_consent"
                  @change="v$.form_marketing_consent.$touch()"
                  :disabled="isInProgress"
                  type="checkbox" :value="'1'" id="fanipay-accepted-newsletter-2">
            
            <span >&nbsp;
              <template v-if="customMarketingConsentTextShort">
                <span v-if="!customMarketingUnfolded"><span v-html="customMarketingConsentTextShort"></span>... </span>  
                  <span v-if="!customMarketingUnfolded" @click="customMarketingUnfolded=true" class="fanipay-show-more">więcej</span>
                <span v-else>
                  <span v-html="customMarketingConsentText"></span>
                </span>
              </template>
              <template v-else>
                <span v-html="customMarketingConsentText"></span>
              </template>
            </span>
          </label>
        </div>

        <button type="button" class="btn btn-red" @click="submitPayment">
          <span v-if="widgetSettings.supportType==='recurring'">
            Wpłacam i chcę wspierać co miesiąc
          </span>
          <span v-else>
            Wpłacam
          </span>
          
          &nbsp;
          <span class="fa"
                :class="{'fa-spin': isFetching, 'fa-refresh': isFetching, 'fa-chevron-right': !isFetching}"></span>
        </button>

    </div>
</template>

<script>
  //import { required, between, minLength, email } from 'vuelidate/lib/validators';
  import { useVuelidate } from '@vuelidate/core'
  import { required, between, minLength, email } from '@vuelidate/validators'

  const touchMap = new WeakMap()

  export function validationEmailPlus(email=''){
    return !email.includes("+");
  }

  export default {
    setup () {
      return { v$: useVuelidate() }
    },
    name: 'direct-support',
    props: ['org', 'widgetSettings'], 
    data () {
      return {
        isFetching: false,
        acceptTermsUnfolded: false,
        acceptPassDetailsUnfolded: false,
        selectedOptionIndex: 2,
        customAmount: '',
        supportTarget: '',
        showSupportTarget: false,
        informationclauseVisible: false,
        handleCosts: false,
        acceptedTerms: false,
        acceptedPassDetails: true,
        customer_first_name: '',
        customer_last_name: '',
        customer_email: '',
        support_day: 7,
        form_marketing_consent: false, 
        customMarketingConsent: this.widgetSettings.customMarketingConsent,
        customMarketingConsentText: this.widgetSettings.customMarketingConsentText,
      }
    },
    mounted () {
      if(this.widgetSettings.supportType=='recurring'){
        this.selectOption(1);
      }

      // pre-fill and select custom amount option if that parameter was given
      if (this.widgetSettings.customAmount) {
        this.customAmount = this.widgetSettings.customAmount;
        this.selectOption(this.paymentOptions.length - 1);
      }

      if (this.widgetSettings.supportTarget) {
        this.supportTarget = this.widgetSettings.supportTarget;
        this.showSupportTarget = true;
      }
    },
    computed: {
      paymentOptions () {
        let options = this.widgetSettings.predefinedAmounts.map(item => {
          return {amount: item.amount, label: item.amount + ' zł'}
        });
        options.push({amount: this.customAmount, label: 'Inna'});
        return options;
      },
      selectedOption () {
        return this.paymentOptions[this.selectedOptionIndex];
      },
      customOptionIndex () {
        return this.paymentOptions.length -1;
      },
      isCustomSelected () {
        return this.selectedOptionIndex === this.customOptionIndex;
      },
      amount () {
        if(this.isCustomSelected){
          return parseFloat(this.customAmount.replace(",", "."));
        } else {
          if(typeof this.selectedOption!='undefined'){
            return parseFloat(this.selectedOption.amount);
          } else {
            return 0;
          }
        }
      },
      finalAmount () {
        switch(this.widgetSettings.supportType){
          case 'recurring':
            return this.handleCosts ? ((this.amount / 0.9851)+0.2) : this.amount;
          break;

          default:
            return this.handleCosts ? this.amount / 0.9851 : this.amount;
          break;
        }
      },
      description () {
        const krs = this.widgetSettings.targetKrs,
              target = this.supportTarget,
              org = this.org.name,
              cause = this.widgetSettings.cause,
              maxLength = {
                'single': 60,
                'recurring': 55,
                'link': 60
              };
        
        let descr = `[krs${this.org.krs}] `;
        let charsLeft = maxLength[this.widgetSettings.supportType] - descr.length;

        switch(this.widgetSettings.supportType){
          default:
            if (target) {
              return `/krs${krs}/ ${target.substr(0, 30)}: ${org}`.substr(0, maxLength[this.widgetSettings.supportType]);
            } else {
              return `/krs${krs}/ ${org}`.substr(0, maxLength[this.widgetSettings.supportType]);
            }
          break;

          case 'link':
            return `/link/${this.widgetSettings.paymentLink}`.substr(0, maxLength[this.widgetSettings.supportType]);
          break;

          case 'recurring':
            if(cause!=''){
              return `/ID${this.org.id}/CYKL/${cause} ${this.org.name}`.substr(0, maxLength[this.widgetSettings.supportType]);
            } else {
              return `/ID${this.org.id}/CYKL/ ${this.org.name}`.substr(0, maxLength[this.widgetSettings.supportType]);
            }
          break;
        }
      },
      customMarketingConsentTextShort() {
        if(this.htmlStrip(this.customMarketingConsentText).length>100){
          return this.htmlSubstr(this.customMarketingConsentText,100);
        } else {
          return false;
        }
      }
    },
    methods: {
      delayTouch(v$) {
        v$.$reset()
        if (touchMap.has(v$)) {
          clearTimeout(touchMap.get(v$))
        }
        touchMap.set(v$, setTimeout(v$.$touch, 1000))
      },
      selectOption (index) {
        this.selectedOptionIndex = index;
        if (this.v$.customAmount.$dirty) {
          this.v$.amount.$touch();
        }
        // Focus custom amount field when custom is selected:
        this.$nextTick(function () {
          if (this.isCustomSelected) {
            this.$refs.customAmountInput.focus();
          }
        });
      },
      selectSupportDay (day) {
        this.support_day=day
      },
      showTarget (e) {
        e.preventDefault();
        this.showSupportTarget = true;
        this.$nextTick(function () {
          this.$refs.supportTargetInput.focus();
        });
      },
      submitPayment () {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }

        let postData = {
          customer_first_name: this.customer_first_name,
          customer_last_name: this.customer_last_name,
          customer_email: this.customer_email,
          amount: this.finalAmount.toFixed(2),
          service_id: this.widgetSettings.serviceId,
          org_id: this.widgetSettings.org_id,
          support_day: this.support_day,
          support_type: this.widgetSettings.supportType,
          description: this.description,
          pass_details: this.acceptedPassDetails,
          payment_link_slug: this.widgetSettings.paymentLink,
          marketing_consent: this.form_marketing_consent, 
        };

        this.isFetching = true;
          fetch(this.widgetSettings.linkApi + '?clean_description', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData)
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              window.location = data.link;
            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });
      },
      htmlStrip(html){
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText;
      },
      htmlSubstr(str,count){
        var div = document.createElement('div');
        div.innerHTML = str;
        
        walk( div, track );
        
        function track( el ) {
            if( count > 0 ) {
                var len = el.data.length;
                count -= len;
                if( count <= 0 ) {
                    el.data = el.substringData( 0, el.data.length + count );
                }
            } else {
                el.data = '';
            }
        }
          
        function walk( el, fn ) {
            var node = el.firstChild, oldNode;
            do {
                if( node.nodeType === 3 ) {
                    fn(node);
                } else if( node.nodeType === 1 ) {
                    walk( node, fn );
                }
            } while( (node = node.nextSibling) && (count>0));
            //remove remaining nodes
            while(node){
                oldNode = node;
                node = node.nextSibling;
                el.removeChild(oldNode);
            }
            
        }
        return div.innerHTML;
      }
    },
    validations(){
      return {
        customAmount: {}, // watch if $dirty but don't validate directly
        amount: {
          required,
          between: between(1, 100000000)
        },
        acceptedTerms: {
          required
        },
        acceptedPassDetails: {
          required
        },
        customer_first_name: {
          required,
          minLength: minLength(3)
        },
        customer_last_name: {
          required,
          minLength: minLength(3)
        },
        customer_email: {
          required,
          email,
          validationEmailPlus
        },
        form_marketing_consent: {  },
      }
    }
  }
</script>